module.exports = __webpack_public_path__ + "left.3pRmT2dx.svg";